import React, { useCallback } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useDispatch } from 'react-redux'

import Button from '@material-ui/core/Button'

import userActions from '../store/modules/user'

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(5),
  },
}))

const Login = ({

} = {}) => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const onLogin = useCallback(() => {
    dispatch(userActions.login())
  }, [])

  return (
    <div className={ classes.root }>
      <Button
        variant="contained"
        color="primary"
        onClick={ onLogin }
      >
        Login
      </Button>
    </div>
  )
}

export default Login